/**
 * Email drafts being sent right now (between Send and the provider taking it), app-wide like `isDraftSent`
 * (workspace.ts). The phone draft sheet closes as soon as a send starts and the conversation's mail card shows
 * "Sending…" until it has gone, or the creator hits Undo on the toast. The send itself keeps running after the
 * sheet (and its composer) is gone. (A single draft opened from a "3 drafts" list opens in the workspace sheet,
 * not here: see openArtifact's `inside`.)
 */
import { reactive } from 'vue'

const sending = reactive(new Set<string>())

export function markDraftSending(id: string, on: boolean): void {
    if (on) sending.add(id)
    else sending.delete(id)
}

export function isDraftSending(id: string): boolean {
    return sending.has(id)
}
